import EventCreateDone from '@/screens/EventCreateDone';

export default function PrivateEventCreateEventIdRoute() {
  return <EventCreateDone />;
}
